import React from "react";

const Block = ({ title, children }) => (
  <section className="mt-8"><h2 className="font-display text-xl font-semibold">{title}</h2><div className="mt-2 space-y-2 text-sm leading-relaxed text-muted-foreground">{children}</div></section>
);

export default function Privacy() {
  return (
    <div className="mx-auto max-w-2xl px-5 pt-10 md:pt-14">
      <h1 className="font-display text-3xl font-semibold tracking-tight md:text-4xl">Privacy Policy</h1>
      <p className="mt-3 text-sm text-muted-foreground">Your trust matters. Here's how Jaanlo handles your information.</p>
      <Block title="What we collect">
        <p>To create a personalized reading we may collect your name, date of birth, birth time and birthplace, your selected questions, and your purchase history. Birth date, birth time and birthplace are treated as personal data.</p>
      </Block>
      <Block title="Consent before saving">
        <p>We only save your birth profile to your account when you explicitly choose to. You can use Jaanlo and receive a reading without creating an account.</p>
      </Block>
      <Block title="How we use it">
        <p>Your details are used solely to generate your personalized interpretation and to let you access your purchased readings. Interpretations are produced through traditional calculations converted into plain language by AI, processed securely on our backend.</p>
      </Block>
      <Block title="What we never do">
        <p>We never sell your personal data. We never share your birth details, financial information or private relationship information when you share a reading.</p>
      </Block>
      <Block title="Your controls">
        <p>You can edit your birth profile, delete your birth data, or delete your account entirely at any time from your Profile page. Deleting your account permanently removes your readings and data.</p>
      </Block>
      <Block title="Security">
        <p>Data is stored securely and payment details are handled by Razorpay. We do not store card information.</p>
      </Block>
    </div>
  );
}
